
import { convertDateToString } from '../common/ConvertTools.js'

export const exportRunAsJson = (contentRunSelected, contentData) => {
  let contentRunSelectedJson = contentRunSelected;
  contentRunSelectedJson.data = contentData
  const fileData = JSON.stringify({ contentRunSelectedJson }, null, 2);
  const blob = new Blob([fileData], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = convertDateToString(contentRunSelected.timestamp / 1000).replace("/", "-") + " - " + contentRunSelected.ble_name + ".json";
  link.href = url;
  link.click();
}

export const exportRunAsCsv = (contentRunSelected, contentData) => {


  const fields = [
    "date",
    "voltage",
    "current",
    "power",
    "speed",
    "speedGps",
    "controllerTemp",
    "motorTemp",
    "positionGps_latitude",
    "positionGps_longitude",
    "errors",
    "acceleration",
    "dutyMaster",
    "dutySlave",
    "throttlePercent",
    "brakePercent",
    "currentMot1",
    "currentMot2"
  ]

  let value = 0
  var modifiedFields = fields.map(field => field.replace(/\./g, '_'));
  var csv = modifiedFields.join(';') + '\r\n';

  contentData.forEach(data => {
    // console.log("DataLogger / pushData / normal / data :", data)

    let dataBuffer = []
    fields.forEach(item => {
      // console.log("DataLogger / pushData / normal / item :", item)
      try {
        value = data[item]
      } catch (err) {
        console.error("DataLogger / pushData / err3", err);
      }
      dataBuffer.push(value)
    });
    var newLineCsv = dataBuffer.join(';')
    csv = csv + newLineCsv + '\r\n';

  })


  const fileData = csv;
  const blob = new Blob([fileData], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = convertDateToString(contentRunSelected.timestamp / 1000).replace("/", "-") + " - " + contentRunSelected.ble_name + ".csv";
  link.href = url;
  link.click();
}

export const exportRunAsOverlayCsv = (contentRunSelected, contentData) => {

  /*
  const fields = [
    {"dbName" : "date", "csvName" : "time (ms)"},
    {"dbName" : "voltage", "csvName" : "voltage (V)"},
    {"dbName" : "current", "csvName" : "current (A)"},
    {"dbName" : "power", "csvName" : "power (W)"},
    {"dbName" : "speed", "csvName" : "speed (s)"},
    {"dbName" : "speedGps", "csvName" : "speedGps (km/h)"},
    {"dbName" : "controllerTemp", "csvName" : "temperatureController (°C)"},
    {"dbName" : "motorTemp", "csvName" : "temperatureMotor (°C)"},
    {"dbName" : "positionGps_latitude", "csvName" : "lat (deg)"},
    {"dbName" : "positionGps_longitude", "csvName" : "lon (deg)"},
    {"dbName" : "errors", "csvName" : "errors"},
    {"dbName" : "acceleration", "csvName" : "accel x (m/s²)"},
    {"dbName" : "dutyMaster", "csvName" : "dutyMaster (%)"},
    {"dbName" : "dutySlave", "csvName" : "dutySlave (%)"},
    {"dbName" : "throttlePercent", "csvName" : "throttle (%)"},
    {"dbName" : "brakePercent", "csvName" : "brake (%)"},
    {"dbName" : "currentMot1", "csvName" : "currentMasterMotor (A)"},
    {"dbName" : "currentMot2", "csvName" : "currentSlaveMotor (A)"},
  ]
  */

  const fields = [
    // { "dbName": "id", "csvName": "id" },
    { "dbName": "voltage", "csvName": "Voltage (V)" },
    { "dbName": "speed", "csvName": "Speed (km/h)" },
    { "dbName": "power", "csvName": "Power (W)" },
    { "dbName": "date", "csvName": "time (ms)" },
    { "dbName": "controllerTemp", "csvName": "Controller Temp (°C)" },
    { "dbName": "motorTemp", "csvName": "Motor Temp (°C)" },
    // { "dbName": "errors", "csvName": "errors" },
    { "dbName": "positionGps_latitude", "csvName": "lat (deg)" },
    { "dbName": "positionGps_longitude", "csvName": "lon (deg)" },
    // { "dbName": "timestampRun", "csvName": "timestampRun" },
    // { "dbName": "device_id", "csvName": "device_id" },
    { "dbName": "current", "csvName": "Current (A)" },
    { "dbName": "dutyMaster", "csvName": "Duty M (%)" },
    { "dbName": "dutySlave", "csvName": "Duty S (%)" },
    { "dbName": "throttlePercent", "csvName": "Throttle (%)" },
    { "dbName": "brakePercent", "csvName": "Brake (%)" },
    { "dbName": "currentMot1", "csvName": "Motor M (A)" },
    { "dbName": "currentMot2", "csvName": "Motor S (A)" },
    { "dbName": "acceleration", "csvName": "Acceleration (g)" },
  ]


  // id,owner_email,voltage (V),speed,speed (m/s),power (W),controllerTemp (°C),motorTemp (°C),errors,lat (deg),lon (deg),timestampRun,date,device_id,current,dutyMaster,dutySlave,throttle (%),brake (%),currentMot1,currentMot2,acceleration (g),lock


  // let toastId = processShowToast();

  var csv = fields.map(field => field.csvName.replace(/\./g, '_')).join(',') + '\r\n';

  let firstDate = 0

  contentData.forEach(data => {
    let dataBuffer = [];
    fields.forEach(item => {
      let value;
      try {
        value = data[item.dbName];  // If the field doesn't exist in data, set value to an empty string

        if (item.dbName === 'date') {
          if (firstDate == 0)
            firstDate = value
          value = value - firstDate
        }

        if (item.dbName === 'acceleration') {
          value = value / 9.81
        }
        if (item.dbName === 'lock')
          value = 0;
      } catch (err) {
        console.error("DataLogger / pushData / err3", err);
      }
      dataBuffer.push(value);
    });
    var newLineCsv = dataBuffer.join(',');
    csv = csv + newLineCsv + '\r\n';
  });

  const blob = new Blob([csv], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = convertDateToString(contentRunSelected.timestamp / 1000).replace("/", "-") + " - " + contentRunSelected.ble_name + ".csv";
  link.href = url;
  link.click();

  // processDismissToast(toastId);
}

export const exportRunAsGpx = (contentRunSelected, contentData) => {

  let mapData = contentData.map(item => [item.positionGps_longitude, item.positionGps_latitude])

  // console.log("mapData", mapData)
  let geojsonRoute = {
    'type': 'Feature',
    'properties': {},
    'geometry': {
      'type': 'LineString',
      'coordinates': mapData
    }
  }

  // console.log("geojsonRoute", geojsonRoute)

  var togpx = require('togpx');
  const fileData = togpx(geojsonRoute);
  // console.log("fileData", fileData)

  const blob = new Blob([fileData], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = convertDateToString(contentRunSelected.timestamp / 1000).replace("/", "-") + " - " + contentRunSelected.ble_name + ".gpx";
  link.href = url;
  link.click();
}